<template>
    <div class="notification-item">
        <div @click="$emit('click', item)" class="p-2 cursor-pointer">
            <div class="flex">
                <vx-basic-icon v-if="showIcon" rounded color="warning" icon="MailIcon" size="10" />
                <div class="w-full">
                    <div class="ml-2 flex justify-between">
                        <h4 class="uppercase">
                            {{ item.title }}
                        </h4>
                        <vs-chip
                            color="danger"
                            v-if="item.isImportant"
                            class="new-notification-chip"
                        >
                        </vs-chip>
                    </div>
                    <div class="flex justify-end">
                        <small class="lighten-font italic">{{ humanizedDate }} </small>
                    </div>
                </div>
            </div>
            <div class="break-words">
                <p class="overflow-anywhere mt-1">
                    {{ item.body }}
                </p>
            </div>
        </div>
        <div class="flex justify-end mt-3 mr-2 mb-2">
            <vx-basic-icon
                rounded
                @click="dismissNotification(item)"
                icon="BellOffIcon"
                size="6"
                class="cursor-pointer"
                color="danger"
            ></vx-basic-icon>
        </div>
        <vs-divider class="my-0" />
    </div>
</template>

<script>
export default {
    name: 'new-notification-item',
    props: {
        item: {
            type: Object
        },
        showIcon: {
            type: Boolean,
            default: true
        },
        humanizedDate: {
            type: String,
            default: ''
        }
    },
    data() {
        return {}
    },
    methods: {
        dismissNotification(notification) {
            this.$store.dispatch('notification/dismissNotification', notification.id)
        }
    }
}
</script>

<style lang="scss" scoped>
.overflow-anywhere {
    overflow-wrap: anywhere;
}
.lighten-font {
    color: #626262;
}
.new-notification-chip {
    padding: 0px !important;
    min-height: 16px !important;
    min-width: 16px !important;
    max-height: 2px !important;
}
</style>
